import { Link } from "react-router-dom";
import Logo from "../../../assets/icons/customLogo.png";

export const CustomLogo = () => {
  return (
    <Link to="/" className="header__krk">
      <img style={{maxWidth:"45px"}} src={Logo} alt="Логотип"></img>
    </Link>
  );
};
